import { render } from "./Instructions.vue?vue&type=template&id=46b139b8"
import script from "./Instructions.vue?vue&type=script&lang=js"
export * from "./Instructions.vue?vue&type=script&lang=js"
script.render = render

export default script